import { MutationTree } from 'vuex';
import {
  SET_NONPROFIT_LIST,
  SET_TOTAL_NONPROFITS_BY_QUERY,
  SET_SELECTED_CAUSES,
  SET_TEMPLATE,
  UPDATE_NONPROFIT_LIST,
  SET_QUERY_NUMBER,
  SET_REMOTE_FRIENDLY,
  SET_MEMBER_METROPOLITAN_AREAS,
  SET_OPEN_OPPORTUNITIES,
  SET_KEYWORDS,
  SET_EVENT_TYPES,
  SET_FUNNEL_TYPES
} from './mutation-types';
import State from './state';
import camelizer from '../../../../../../services/convertDataStrategies/classes/camelizer';
import { INonprofit } from '../../../models/interfaces/searchAndDiscovery/iNonprofit'
import { ICause } from "../../../models/interfaces/iCause";
import { IKeyName } from '../../../models/interfaces/IKeyName';
import { IMetropolitanArea } from '../../../models/interfaces/iMetropolitanArea';

const mutations: MutationTree<State> = {
  [SET_NONPROFIT_LIST](state: State, nonprofits: INonprofit[]): void {

    //applications = Object.keys(applicationsCard).reduce((acc, key) => {
    //  const _acc = acc;
    //  if (applicationsCard[key] !== undefined)
    //    _acc[key] = applicationsCard[key];

    //  return _acc;
    //}, {})
    state.profile.nonprofits = nonprofits;
  },

  [UPDATE_NONPROFIT_LIST](state: State, nonprofits: INonprofit[]): void {
    const currentNonprofits = state.profile.nonprofits;

    state.profile.nonprofits = [...currentNonprofits, ...nonprofits];
  },

  [SET_TOTAL_NONPROFITS_BY_QUERY](state: State, totalNonprofitsByQuery: number): void {

    state.profile.totalNonprofitsByQuery = totalNonprofitsByQuery;
  },

  [SET_SELECTED_CAUSES](state: State, selectedCauses: ICause[]): void {

    state.profile.selectedCauses = selectedCauses;
  },

  [SET_TEMPLATE](state: State, template: string): void {

    state.profile.template = template;
  },

  [SET_QUERY_NUMBER](state: State, queryNumber: number): void {

    state.profile.queryNumber = queryNumber;
  },
  [SET_REMOTE_FRIENDLY](state: State, remoteFriendly: IKeyName[]): void {

    state.profile.selectedRemotefriedly = remoteFriendly;
  },
  [SET_MEMBER_METROPOLITAN_AREAS](state: State, metropolitanAreas: IMetropolitanArea[]): void {

    state.profile.selectedMemberMetropolitanAreas = metropolitanAreas;
  },
  [SET_OPEN_OPPORTUNITIES](state: State, openOpportunities: IKeyName[]): void {

    state.profile.selectedOppenOpportunities = openOpportunities;
  },
  [SET_EVENT_TYPES](state: State, eventTypes: IKeyName[]): void {

    state.profile.selectedEventTypes = eventTypes;
  },
  [SET_FUNNEL_TYPES](state: State, prefTypes: IKeyName[]): void {

    state.profile.selectedPrefTypes = prefTypes;
  },
  [SET_KEYWORDS](state: State, keywords: string[]): void {

    state.profile.keywords = keywords;
  }
};

export default mutations;


// WEBPACK FOOTER //
// ./static-content/private/javascripts/store/modules/searchAndDiscovery/mutations.ts